import React from "react";

import { faExternalLinkAlt } from "@fortawesome/pro-solid-svg-icons/faExternalLinkAlt";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useIntl } from "react-intl";

import { EntitiesSupportedByMapsPage, MapEntity } from "@mapmycustomers/shared/types/entity";

import ButtonLink from "@app/component/ButtonLink";
import Path from "@app/enum/Path";

import styles from "./MapLink.module.scss";

interface Props {
  entity: EntitiesSupportedByMapsPage;
}

const MapLink: React.FC<Props> = ({ entity }) => {
  const intl = useIntl();

  if (!entity.geoPoint?.coordinates) {
    return null;
  }

  const coordinates = entity.geoPoint.coordinates.map(String).join(",");
  const entityType = (entity as MapEntity).entity;
  const url = `${Path.MAP}/entity/${entityType}/${entity.id}?center=${coordinates}`;

  return (
    <div className={styles.container}>
      <ButtonLink href={url} target="_blank">
        {intl.formatMessage({
          id: "recordPane.mapLink.title",
          defaultMessage: "Open Record on Map View",
          description: "Open Record on Map View link title",
        })}
        <FontAwesomeIcon className={styles.icon} icon={faExternalLinkAlt} />
      </ButtonLink>
    </div>
  );
};

export default MapLink;
